module.exports = __webpack_public_path__ + "img/AT0000002419545.1244d970.png";